import React from 'react';
import { Home } from 'lucide-react';
import { cloudinaryOptimize } from '../utils/cloudinaryOptimize';

const REA_ADS = [
  { img: "https://res.cloudinary.com/dcepccggr/image/upload/v1784005378/hss/rea-ads/rea-ad-banya.png" },
  { img: "https://res.cloudinary.com/dcepccggr/image/upload/v1784005379/hss/rea-ads/rea-ad-nirimba.png" },
  { img: "https://res.cloudinary.com/dcepccggr/image/upload/v1784005380/hss/rea-ads/rea-ad-mooloolaba.png" },
  { img: "https://res.cloudinary.com/dcepccggr/image/upload/v1784005380/hss/rea-ads/rea-ad-maroochydore.png" },
  { img: "https://res.cloudinary.com/dcepccggr/image/upload/v1784005381/hss/rea-ads/rea-ad-multiple.png" },
];

const HssDifferenceTable = ({ dailyProps }) => (
  <div className="carousel-diff-right" data-testid="hss-difference">
    <h2 className="hss-diff-title" style={{ fontSize: '36px', textAlign: 'center' }}>The HSS Difference</h2>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 40px 1fr', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden' }}>
      <div className="hss-diff-header hss-diff-header-rea">Private Renting</div>
      <div style={{ background: '#1a2332' }} />
      <div className="hss-diff-header hss-diff-header-hss">HSS Solution</div>
      {REA_ADS.map((ad, idx) => {
        const p = dailyProps[idx];
        const pr = p ? p.weekly_rent_per_person : 0;
        const pCRA = Math.min(73.23, Math.max(0, 0.75 * (pr - 74.10)));
        return (
          <React.Fragment key={ad.img || idx}>
            <div style={{ borderTop: '1px solid #f3f4f6', padding: '6px' }}>
              <img src={ad.img} alt={`REA ad ${idx+1}`} style={{ width: '100%', borderRadius: '6px', display: 'block' }} onError={e => e.target.style.display='none'} />
            </div>
            <div style={{ background: '#1a2332', display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: '1px solid #2d3748' }}>
              {idx === Math.floor(REA_ADS.length / 2) && <span style={{ fontSize: '28px', color: '#fbbf24', fontWeight: '900' }}>&#9889;</span>}
            </div>
            <div style={{ borderTop: '1px solid #f3f4f6', background: '#f0fdf4' }}>
              {p ? (
                <>
                  {p.images?.[0] ? (
                    <img src={cloudinaryOptimize(p.images[0], 400)} alt={p.city} style={{ width: '100%', display: 'block' }} onError={e => e.target.style.display='none'} />
                  ) : (
                    <div style={{ height: '120px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#d1fae5' }}>
                      <Home size={40} color="#059669" />
                    </div>
                  )}
                  <div style={{ padding: '8px 10px', textAlign: 'center' }}>
                    <div style={{ fontWeight: '700', fontSize: '14px', color: '#1a2332', marginBottom: '4px' }}>{p.city}, {p.state}</div>
                    <span className="hss-diff-tag hss-diff-tag-hss">{p.total_bedrooms}-BED HOUSE</span>
                    <div style={{ marginTop: '4px', lineHeight: 1 }}>
                      <span style={{ fontSize: '14px', fontWeight: '800', color: '#1a2332' }}>$</span>
                      <span style={{ fontSize: '20px', fontWeight: '900', color: '#1a2332' }}>{Math.round(pr - pCRA)}</span>
                      <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>/pw Singles</span>
                    </div>
                    <div style={{ marginTop: '2px', lineHeight: 1 }}>
                      <span style={{ fontSize: '14px', fontWeight: '800', color: '#1a2332' }}>$</span>
                      <span style={{ fontSize: '20px', fontWeight: '900', color: '#1a2332' }}>{Math.round(pr - Math.min(103.40, Math.max(0, 0.75 * (pr - 123.10))))}</span>
                      <span style={{ fontSize: '12px', fontWeight: '600', color: '#6b7280' }}>/pw Couples</span>
                    </div>
                  </div>
                </>
              ) : <span style={{ color: '#9ca3af', fontSize: '13px', padding: '20px', display: 'block', textAlign: 'center' }}>Loading...</span>}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  </div>
);

export default HssDifferenceTable;
